import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';

const TaxExemptionReasonCodeSelect = ({ name, label, control, errors, readOnly = false, setValue }) => {
  const { common } = useTranslatedMessages();
  const taxExemptionReasonCodeSelect = common.tax_exemption_reason_code_select ?? {};
  const resolvedLabel = label ?? taxExemptionReasonCodeSelect.label;
  const taxExemptionReasonCodesList = useSelector((state) => state.codeLists.taxExemptionReasonCodesList) ?? [];

  const getSelectedOption = (code) => {
    return taxExemptionReasonCodesList.find((item) => item.code === code) || null;
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          id="tax-exemption-reason"
          options={taxExemptionReasonCodesList}
          readOnly={readOnly}
          getOptionLabel={(option) => `${option.code} - ${option.reason}`}
          isOptionEqualToValue={(option, value) => option.code === value?.code}
          value={getSelectedOption(field.value)}
          onChange={(_, selected) => {
            field.onChange(selected?.code ?? '');
            // Also set the tax_exemption_reason field with the description
            if (setValue && name) {
              const reasonFieldName = name.replace('.tax_exemption_reason_code', '.tax_exemption_reason');
              setValue(reasonFieldName, selected?.reason ?? null, { shouldValidate: false });
            }
          }}
          fullWidth
          sx={{
            '& .MuiInputBase-root': {
              alignItems: 'start', // Align input content to top
              paddingTop: '10px',
              whiteSpace: 'normal',
            },
            '& .MuiAutocomplete-input': {
              whiteSpace: 'normal !important',
              wordBreak: 'break-word',
            },
          }}
          ListboxProps={{
            sx: {
              '& .MuiAutocomplete-option:nth-of-type(odd)': {
                backgroundColor: 'background.paper',
              },
              '& .MuiAutocomplete-option:nth-of-type(even)': {
                backgroundColor: 'grey.200',
              },
              '& .MuiAutocomplete-option:hover': {
                backgroundColor: 'grey.100',
              },
            },
          }}
          renderInput={(params) => {
            const errorObj = get(errors, name);
            return (
              <TextField
                {...params}
                id="tax-exemption-reason"
                label={resolvedLabel}
                error={!!errorObj}
                helperText={errorObj?.message}
                fullWidth
                multiline // <- allows multi-line wrapping
                InputProps={{
                  ...params.InputProps,
                  sx: {
                    alignItems: 'start',
                    paddingTop: '10px',
                    whiteSpace: 'normal',
                  },
                }}
              />
            );
          }}
        />
      )}
    />
  );
};

export default TaxExemptionReasonCodeSelect;
